<template>
  <div>
    <va-inner-loading :loading="loader">
      <va-card class="mb-4">
        <div class="d-flex justify--space-between">
          <h1>Отзывы флористов</h1>
          <va-button color="info" @click="showModal = true">
            Добавить отзыв
          </va-button>
        </div>
        <div v-if="florists.length" class="mt-3" style="max-width: 300px">
          <va-select
            v-model="selectedFloristId"
            :options="florists"
            text-by="name"
            value-by="id"
            placeholder="Фильтр по флористу"
            clearable
            @input="loadReviews"
          />
        </div>
      </va-card>

      <florist-reviews-table
        class="mb-4"
        :reviews="reviews"
        :florists="florists"
        @refresh="loadReviews"
      />
      <va-modal v-model="showModal" size="large" hide-default-actions>
        <florist-review-create
          :florists="florists"
          @close="showModal = false"
          @created="handleCreated"
        ></florist-review-create>
      </va-modal>
    </va-inner-loading>
  </div>
</template>

<script>
import FloristReviewCreate from '../../components/florist-reviews/florist-review-create.vue';
import FloristReviewsTable from '../../components/florist-reviews/florist-reviews-table.vue';
import api from '@/api/axios';
import { mapGetters } from 'vuex';

export default {
  name: 'FloristReviews',
  components: { FloristReviewCreate, FloristReviewsTable },
  data() {
    return {
      showModal: false,
      reviews: [],
      florists: [],
      selectedFloristId: null,
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      loader: 'isLoading',
    }),
  },
  async created() {
    await this.loadFlorists();
    await this.loadReviews();
  },
  methods: {
    async loadFlorists() {
      try {
        const response = await api.get('/admin/florists', { params: { all: 1 } });
        this.florists = response.data.data || [];
      } catch (error) {
        console.error('Ошибка загрузки флористов:', error);
        this.florists = [];
      }
    },
    async loadReviews() {
      this.loading = true;
      try {
        const params = { all: 1 };
        if (this.selectedFloristId) {
          params.florist_id = this.selectedFloristId;
        }
        const response = await api.get('/admin/florist-reviews', { params });
        // Обрабатываем как пагинацию, так и простой массив
        this.reviews = response.data.data || response.data || [];
      } catch (error) {
        console.error('Ошибка загрузки отзывов:', error);
        this.reviews = [];
      } finally {
        this.loading = false;
      }
    },
    handleCreated() {
      this.showModal = false;
      this.loadReviews();
    },
  },
};
</script>

<style></style>

